import { useEffect, useState } from "react";
import { getCartonURL } from "../utils/ConstantsURL";

export const useFetchCartones = (
    token,
    selectedDate,
    selectedIdSection,
    refresh,
    idDocument
  ) => {
    const [cartones, setCartones] = useState([]);
    const [loadingCarton, setLoadingCarton] = useState(false);
  
    useEffect(() => {
      const fetchCartones = async () => {
        setLoadingCarton(true);
        try {
            const response = await fetch(
                getCartonURL(selectedDate, idDocument, selectedIdSection),
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(
                    errorData.message || "Ocurrió un error al obtener los cartones."
                );
            }

            const data = await response.json();
            setCartones(data.data);
            setLoadingCarton(false);
        } catch (error) {
            setCartones([]);
            setLoadingCarton(false);
        }
    };

    fetchCartones();

    }, [token, selectedDate, selectedIdSection, refresh, idDocument]);
    
    return { cartones, loadingCarton };
};
